export default __webpack_public_path__ + "static/media/veilspun.36122ff1.png";